export default __webpack_public_path__ + "static/media/neighborhood2.fce4a894.webp";